<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div v-if="isLoading" class="loading_bg" style="z-index: 600;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                         xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 892px; height: 700px;">
            <div class="pop_title">
                <span class="title">{{ $t('work_schedule.popup_work_code_settings.title') }}</span>
                <button class="mgl_auto" @click="action_Close">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>

            <div class="pop_desc lgray black_txt" style="border-bottom: 1px solid var(--gray60);">
                {{ $t('work_schedule.popup_work_code_settings.sub_title') }}
            </div>

            <div class="pop_cont">
                <div class="table_top_wrap">
                    <b>{{ $t('work_schedule.popup_work_code_settings.label_work_code') }}</b>
                    <div class="mgl_auto">
                        <button class="btn btn_gray_line btn_s " @click="action_AddItem(true)"><b>＋ {{ $t('work_schedule.popup_work_code_settings.label_time_off') }}</b></button>
                        <button class="btn btn_blue_line btn_s " @click="action_AddItem">＋ {{ $t('work_schedule.popup_work_code_settings.label_work') }}</button>
                    </div>
                    <!-- <button class="btn btn_blue_line btn_s mgl_auto" @click="action_AddItem">＋ 추가</button> -->
                </div>

                <div ref="scroll" class="table2_xyscroll sticky" style="height: 400px;">
                    <table class="table2_default rsv_program_set">
                        <colgroup>
                            <col width="45">
                            <col width="200">
                            <col width="361">
                            <col width="144">
                            <col width="115">
                        </colgroup>
                        <thead>
                        <tr>
                            <th class="txt_center">{{ $t('work_schedule.popup_work_code_settings.label_color') }}</th>
                            <th class="txt_center">{{ $t('work_schedule.popup_work_code_settings.label_code') }}</th>
                            <th class="txt_center">{{ $t('work_schedule.popup_work_code_settings.label_work_hours') }}</th>
                            <th class="txt_center">{{ $t('work_schedule.popup_work_code_settings.label_change_order') }}</th>
                            <th class="txt_center">{{ $t('common.delete') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <CodeItem
                            v-for="(code, index) in modifiedItems" :key="index"
                            :value="code"
                            :index="index"
                            :isTop="index==0"
                            :isBottom="index==modifiedItems.length-1"
                            @updateValue="updateValue"
                            @showColorPalette="showColorPalette"
                            @removeValue="removeValue"
                            @moveToTop="moveToTop"
                            @moveToUp="moveToUp"
                            @moveToDown="moveToDown"
                            @moveToBottom="moveToBottom"
                        />
                        </tbody>
                    </table>
                </div>
                <div class="rsv_program_set">
                    <Palette
                        :isShow="isShowColorPalette"
                        :selectedCodeInfo="selectedWorkCode"
                        @closeColorPalette="closeColorPalette"
                        @updateValue="updateValue"
                    />
                </div>
                <small class="red_txt mgt_10" v-if="hasError">{{ errorMessage }}</small>

                <div class="btn_wrap">
                    <!-- <span class="editor_info mgr_auto">2022-10-24 08:45 / 최실장 수정</span> -->
                    <button class="btn btn_l btn_blue" @click="action_Save">{{ $t('common.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import CodeItem from './CodeItem.vue'
import Palette from './ColorPalette.vue'

const moment = require('@/util/MPMoment')
import { workerState, setSelectedDate } from '../../worker-state'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2WorkCodeListQueryOptions } from '@/composables/queries/v2workcode/use-v2-workcode-find-query'
import { useV2WorkCodeCreateMutation } from '@/composables/queries/v2workcode/use-v2-workcode-create-mutation'
import { useV2WorkCodeUpdateMutation } from '@/composables/queries/v2workcode/use-v2-workcode-update-mutation'
import { useV2WorkCodeRemoveMutation } from '@/composables/queries/v2workcode/use-v2-workcode-remove-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: createWorkCode } = useV2WorkCodeCreateMutation()
        const { mutateAsync: updateWorkCode } = useV2WorkCodeUpdateMutation()
        const { mutateAsync: removeWorkCode } = useV2WorkCodeRemoveMutation()
        return { queryClient, createWorkCode, updateWorkCode, removeWorkCode }
    },
    components: { Palette, CodeItem },
    props: {
        isShow: Boolean,
    },
    data() {
        return {
            isLoading: false,

            worker: workerState,
            codes: [],

            modifiedItems: [],
            removalItems: [],

            defaultModel: {
                paletteIndex: 0,
                title: '',
                startedAt: '',
                endedAt: '',
                usingCustomColor: false
            },
            vacationModel: {
                title: "off",
                paletteIndex: 16, // default #9BB1C2 color
                startedAt: "2000-01-02T00:00:00+09:00",
                endedAt: "2000-01-02T23:59:59+09:00",
                isDefault: true
            },
            selectedWorkCode: { // for color palette
                code: undefined,
                index: undefined,
                el: undefined,
                position: { x: 0, y: 0 }
            },

            errorMessage: '',
        }
    },
    watch: {
        isShow: {
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.loadCodes()
                if (this.isShow == true) {
                    this.registKEC()
                    this.errorMessage = ''
                    this.modifiedItems = []
                    this.removalItems = []
                } else {
                    this.unregistKEC()
                }
            }
        },
        codes: {
            handler: async function (newValue) {
                if (newValue.length == 0) {
                    await this.createDefaultCode()
                    await this.loadCodes()
                }
            }
        },
    },
    computed: {
        isShowColorPalette: function () {
            return this.selectedWorkCode.code != undefined
        },
        hasDuplicatedTitle: function () {
            for (let [oIndex, origin] of this.modifiedItems.entries()) {
                for (let [cIndex, compare] of this.modifiedItems.entries()) {
                    if (oIndex == cIndex) { continue }
                    if (origin?.title == compare?.title) { return true}
                }
            }
            return false
        },
        hasEmptyTitle: function () {
            for (let i = 0; i < this.modifiedItems.length; i++) {
                let code = this.modifiedItems[i]
                if (code.title == undefined || code.title == '') { return true }
            }
            return false
        },
        hasError: function () {
            if (this.errorMessage == undefined) { return false }
            return this.errorMessage != ''

        },
        keyEventController: function () {
            return this.worker.keyEventController
        }
    },
    methods: {
        // MARK: - Actions
        action_Close() {
            this.$emit('closeWorkCodeSetting')
        },

        action_AddItem(isVacation) {
            let newCode
            if (isVacation == true) { newCode = deepCopy(this.vacationModel) }
            else { newCode = deepCopy(this.defaultModel) }
            newCode.hospitalID = this.hospital.selectedHospital._id
            newCode.startedAt = moment().startOf('days').format()
            newCode.endedAt = moment().endOf('days').startOf('hours').format()
            this.modifiedItems.push(newCode)
        },
        async action_Save() {
            this.errorMessage = undefined
            if (this.hasDuplicatedTitle) {
                this.errorMessage = '같은 코드명으로 설정된 항목이 있습니다.'
                return
            }
            if (this.hasEmptyTitle) {
                this.errorMessage = '코드명을 입력해주세요.'
                return
            }

            this.isLoading = true

            for (let i = 0; i < this.modifiedItems.length; i++) {
                let item = this.modifiedItems[i]
                item.sortNum = i
            }

            let cArray = this.modifiedItems.filter((m) => m._id == undefined)
            // 변경분만 update — 원본과 편집 가능 필드가 모두 같으면 요청을 보내지 않는다
            let uArray = this.modifiedItems.filter((m) => m._id != undefined && this.isCodeModified(m))
            let rArray = this.removalItems.filter((m) => m._id != undefined)
            let swapArray = []
            for (let i=0 ; i<uArray.length ; i++) {
                let modify = uArray[i]
                let origin = this.codes.find(o => o._id != modify._id && o.title == modify.title)
                if (origin == undefined) { continue }
                let originModified = this.modifiedItems.find(o => o._id == origin._id)
                swapArray.push([originModified, modify])
            }

            for (let i=0 ; i<swapArray.length ; i++) {
                let models = swapArray[i]
                let origin = models[0]
                let modify = models.at(-1)
                await this.swapCodeTitle(origin, modify)
            }
            for (let i = 0; i < cArray.length; i++) {
                await this.createCode(cArray[i])
            }
            for (let i = 0; i < uArray.length; i++) {
                await this.updateCode(uArray[i])
            }
            for (let i = 0; i < rArray.length; i++) {
                await this.removeCode(rArray[i])
            }

            setSelectedDate(moment(this.worker.selectedDate))

            this.isLoading = false

            // await this.loadCodes()
            this.worker.needUpdateCodes = true
            this.action_Close()
        },


        // MARK: - Emit
        updateValue(code, index) {
            this.modifiedItems.splice(index, 1, code)
            if (this.selectedWorkCode.code != undefined) {
                this.selectedWorkCode.code = code
            }

            this.errorMessage = undefined
        },
        showColorPalette(code, index, el) {
            this.$refs.scroll.addEventListener('scroll', this.handleScroll)
            this.selectedWorkCode.code = code
            this.selectedWorkCode.index = index
            this.selectedWorkCode.el = el
            this.handleScroll()
        },
        closeColorPalette() {
            this.$refs.scroll.removeEventListener('scroll', this.handleScroll)
            this.selectedWorkCode = {
                code: undefined,
                index: undefined,
                el: undefined,
                position: { x: 0, y: 0 }
            }
        },
        removeValue(_, index) {
            let removalObjects = this.modifiedItems.splice(index, 1)
            let removalObject = removalObjects[0]
            this.removalItems.push(removalObject)
        },
        moveToTop(item, index) {
            this.modifiedItems.splice(index, 1)
            this.modifiedItems.splice(0, 0, item)
        },
        moveToUp(item, index) {
            this.modifiedItems.splice(index, 1)
            this.modifiedItems.splice(index - 1, 0, item)
        },
        moveToDown(item, index) {
            this.modifiedItems.splice(index, 1)
            this.modifiedItems.splice(index + 1, 0, item)
        },
        moveToBottom(item, index) {
            this.modifiedItems.splice(index, 1)
            this.modifiedItems.splice(this.modifiedItems.length, 0, item)
        },


        // MARK: - Network
        async loadCodes() {
            this.isLoading = true
            let hospitalID = this.hospital.selectedHospital._id


            try {
                this.codes = await this.queryClient.fetchQuery(v2WorkCodeListQueryOptions(hospitalID))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                this.isLoading = false
                return
            }
            this.modifiedItems = deepCopy(this.codes)
            this.modifiedItems.sort((l, r) => {
                return l.sortNum > r.sortNum ? 1 : -1
            })
            this.isLoading = false
        },

        async createDefaultCode() { //create default code when loaded codes is empty
            let hospitalID = this.hospital.selectedHospital._id
            let model = {
                isDefault: true,
                hospitalID: hospitalID,
                title: 'off',
                paletteIndex: 0,
                sortNum: 1,
                startedAt: moment().startOf('days'),
                endedAt: moment().endOf('days'),
                usingCustomColor: false
            }
            try {
                await this.createWorkCode(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async createCode(model) {
            try {
                await this.createWorkCode(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 계속 진행
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        // 편집 가능 필드(코드명·시간·색상)와 재부여된 sortNum 기준으로 원본 대비 변경 여부 판단
        isCodeModified(modified) {
            const origin = this.codes.find((o) => o._id == modified._id)
            if (origin == undefined) { return true }
            const fields = ['title', 'startedAt', 'endedAt', 'usingCustomColor', 'customColorCode', 'paletteIndex', 'sortNum']
            return fields.some((f) => origin[f] != modified[f])
        },
        async updateCode(model) {
            try {
                await this.updateWorkCode(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 계속 진행
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async swapCodeTitle(origin, modify) {
            let originTempModel = {
                _id: origin._id,
                title: origin._id
            }
            try {
                await this.updateWorkCode(originTempModel)
                await this.updateWorkCode(modify)
                await this.updateWorkCode(origin)
            } catch (err) {
                // 기존 동작 미러링: 봉투 에러가 나면 그 지점에서 중단하고 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }

        },
        async removeCode(model) {
            try {
                await this.removeWorkCode(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 계속 진행
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },

        // MARK: - Event Listner
        handleScroll() {
            let rect = this.selectedWorkCode.el.getBoundingClientRect()
            this.selectedWorkCode.position.y = rect.y - (58 + 50)
        },

        registKEC() {
            let routerObj = this.keyEventController.getNextRouteObject('keydown')
            routerObj.groupKey = 'keydown_codesetting'
            routerObj.target = this._uid
            routerObj.policy = this.keyEventController.Enum.RoutingPolicy.Go
            routerObj.handler = this.handleKeyEvent
            this.keyEventController.registRouter(routerObj)
        },
        unregistKEC() {
            this.keyEventController.unregistRouter(this._uid)
        },
        handleKeyEvent() {
        },
    }
}
</script>